import React, {useState, useEffect, useRef} from 'react';
import padUp from "../../assets/icons/button-pad-up.svg";
import padDown from "../../assets/icons/button-pad-down.svg";
import padRight from "../../assets/icons/button-pad-right.svg";
import padLeft from "../../assets/icons/button-pad-left.svg";


const ButtonDPad = (props) => {
  const {positionX=0, positionY=60} = props;
  const [dragging, setDragging] = useState(false);
  const [position, setPosition] = useState({x: positionX, y:positionY});
  const [offset, setOffset] = useState({x: 0, y:0});
  const animationFrameId = useRef(null);
  const isLongPress = useRef(false);
  const clickTimeoutId = useRef(null);

  const handleMouseDown = (e) => {
    setDragging(true);
    setOffset({
      x: -e.clientX - position.x,
      y: e.clientY - position.y,
    })
  };

  const handleMouseMove = (e) => {
    if (dragging) {
      setPosition({
        x: -e.clientX - offset.x,
        y: e.clientY - offset.y
      })
    }
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const scrollTable = (amountX, amountY, behavior='smooth') => {
    window.scrollBy({
      top: amountY,
      left: amountX,
      behavior: behavior,
    });
    const main = document.getElementById('view-main');
    main.scrollBy({ left: amountX, behavior: behavior });
  };

  const handleDoubleClick = (direction) => {
    const main = document.getElementById('view-main');
    if (main) {
      switch (direction) {
        case 'up':
          scrollTable(0, -document.documentElement.scrollHeight, 'auto');
          break;
        case 'down':
          scrollTable(0, document.documentElement.scrollHeight, 'auto');
          break;
        case 'right':
          scrollTable(main.scrollWidth, 0, 'auto');
          break;
        case 'left':
          scrollTable(-main.scrollWidth, 0, 'auto');
          break;
      }
    }
  };

  const startScrolling = (amountX, amountY) => {
    isLongPress.current = false;
    clickTimeoutId.current = setTimeout(() => {
      isLongPress.current = true;
      const scrollStep = () => {
        scrollTable(amountX, amountY,);
        animationFrameId.current = requestAnimationFrame(scrollStep);
      };

      scrollStep();
    }, 200);
  };

  const stopScrolling = () => {
    clearTimeout(clickTimeoutId.current);
    if (animationFrameId.current) {
      cancelAnimationFrame(animationFrameId.current);
      animationFrameId.current = null;
    }
  };

  useEffect(() => {
    if (dragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging]);

  return (
    <div className={`flex items-center gap-[8px] z-40 select-none transition-opacity p-2 w-[180px] h-[140px] rounded-lg  cursor-move ${dragging ? 'opacity-50': 'opacity-100 hover:bg-[#FAFAFA] hover:bg-opacity-50'}`}
         style={{
           right: `${position.x}px`,
           top: `${position.y}px`,
           position: 'fixed'
         }}
         onMouseDown={handleMouseDown}
    >
      <div className="flex justify-center items-center z-100 cursor-pointer hover:opacity-75"
           onMouseDown={(e) => {
             startScrolling(-50, 0);
             e.stopPropagation();
             e.preventDefault();
           }}
           onClick={() => scrollTable(-100, 0)}
           onDoubleClick={() => handleDoubleClick('left')}
           onMouseUp={stopScrolling}
           onMouseLeave={stopScrolling}
      >
        <img src={padLeft} className="w-[48px] h-[48px]" alt="Pad Left Icon"></img>
      </div>
      <div className="flex flex-col items-start gap-[16px] z-100">
        <div className="flex justify-center items-center cursor-pointer hover:opacity-75"
             onMouseDown={
               (e) => {
                 startScrolling(0, -50);
                 e.stopPropagation();
                 e.preventDefault();
               }}
             onClick={() => scrollTable(0, -100)}
             onDoubleClick={() => handleDoubleClick('up')}
             onMouseUp={stopScrolling}
             onMouseLeave={stopScrolling}
        >
          <img src={padUp} className="w-[48px] h-[48px]" alt="Pad Up Icon"></img>
        </div>
        <div className="flex justify-center items-center cursor-pointer hover:opacity-75"
             onMouseDown={
               (e) => {
                 startScrolling(0, 50);
                 e.stopPropagation();
                 e.preventDefault();
               }}
             onClick={() => scrollTable(0, 100)}
             onDoubleClick={() => handleDoubleClick('down')}
             onMouseUp={stopScrolling}
             onMouseLeave={stopScrolling}
        >
          <img src={padDown} className="w-[48px] h-[48px]" alt="Pad Down Icon"></img>
        </div>
      </div>
      <div className="flex justify-center items-center z-100 cursor-pointer hover:opacity-75"
           onMouseDown={
             (e) => {
               startScrolling(50, 0);
               e.stopPropagation();
               e.preventDefault();
             }}
           onClick={() => scrollTable(100, 0)}
           onDoubleClick={() => handleDoubleClick('right')}
           onMouseUp={stopScrolling}
           onMouseLeave={stopScrolling}
      >
        <img src={padRight} className="w-[48px] h-[48px]" alt="Pad Right Icon"></img>
      </div>
    </div>
  )
};

export default ButtonDPad;